import {
  IMedicalCertificate,
  IMedicalCertificateError,
  IMedicalCertificateTypes,
} from './types';

export const medicalCertificateGetRequest = () => ({
  type: IMedicalCertificateTypes.MEDICAL_CERTIFICATE_GET_REQUEST,
});

export const medicalCertificateGetSuccess = (data: IMedicalCertificate[]) => ({
  type: IMedicalCertificateTypes.MEDICAL_CERTIFICATE_GET_SUCCESS,
  payload: {
    data,
  },
});

export const medicalCertificateGetFailure = (error: IMedicalCertificateError) => ({
  type: IMedicalCertificateTypes.MEDICAL_CERTIFICATE_GET_FAILURE,
  payload: {
    error,
  },
});
